// [AUDIT-2026-10-28 M-OPEN-1] A plain-string error the backend sends, in the
// UI's language. The backend raises most of its errors with one English (or
// one Arabic) string; serverMessages.json gives each of them in ar, fr and
// en, keyed by the exact string. A key with "{}" is the backend's f-string,
// each {} a value it filled in; the translation places them as {0}, {1}...
// backend/tests/test_audit_2026_10_28_fixes.py fails when a backend message
// is missing from the catalog, or the catalog holds one the backend dropped.
import CATALOG from './serverMessages.json';

const escapeRe = (s) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const EXACT = new Map();
const PATTERNS = [];
for (const [key, tr] of Object.entries(CATALOG)) {
  if (key.includes('{}')) {
    PATTERNS.push([new RegExp(`^${key.split('{}').map(escapeRe).join('(.+?)')}$`, 's'), tr]);
  } else {
    EXACT.set(key, tr);
  }
}

const pick = (tr, language) => {
  const lng = String(language || 'ar').slice(0, 2);
  return tr[lng] || tr.en || tr.ar || '';
};

export function translateServerMessage(text, language) {
  if (typeof text !== 'string') return text;
  const hit = EXACT.get(text) || EXACT.get(text.trim());
  if (hit) return pick(hit, language) || text;
  for (const [rx, tr] of PATTERNS) {
    const m = text.match(rx);
    if (m) {
      const out = pick(tr, language);
      return out ? out.replace(/\{(\d+)\}/g, (_, i) => m[Number(i) + 1] ?? '') : text;
    }
  }
  return text;
}

export default translateServerMessage;
